import { useState, useRef } from 'react';

function ExclusiveSect() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const sliderRef = useRef<HTMLDivElement>(null);

    const handleSlide = (direction: 'left' | 'right') => {
        if (!sliderRef.current) return;
        
        const newIndex = direction === 'left' 
            ? Math.max(0, currentIndex - 1)
            : Math.min(3, currentIndex + 1);
        
        setCurrentIndex(newIndex);
        
        sliderRef.current.scrollTo({
            left: newIndex * sliderRef.current.offsetWidth,
            behavior: 'smooth'
        });
    };

    return (
        <div className="flex flex-col md:flex-row w-full bg-[#f9f9f9] p-2 rounded-sm items-center">
            <div className="w-full md:w-7/12 p-4">
                <h2 className="text-xl font-semibold mb-2 mt-4">What Makes All-Exclusive Holidays Unique?</h2>
                <p className="text-black mb-2">Our <span className="font-medium">all-exclusive holidays</span> go beyond the typical luxury getaway, offering a refined experience that caters exclusively to guests who value privacy, luxury, and personalized services. What makes our exclusive offerings stand out?</p>
                <h3 className="text-lg font-semibold mb-4 mt-4">Available Benefits:</h3>
                <ul className="custom-bullet pl-5 space-y-1 text-gray-800">
                    <li><span className="font-medium text-black">Private Resorts and Villas</span> – Secluded locations with private access and opulent surroundings.</li>
                    <li><span className="font-medium text-black">Dedicated Butler Service</span> – A personal butler to attend to your needs and enhance your experience.</li>
                    <li><span className="font-medium text-black">Exclusive Dining Experiences</span> – From private chefs to personalized menus, each meal is a culinary journey.</li>
                    <li><span className="font-medium text-black">Tailored Experiences</span> – Curated activities, spa treatments, and excursions designed just for you.</li>
                </ul>
                <p className="text-black mt-4">Our <span className="font-medium">all-exclusive holidays</span> are crafted to provide the ultimate in luxury, privacy, and attention to detail.</p>
            </div>
            <div className="hidden md:block w-px bg-gray-300 h-auto mx-4"></div>
            <div className="w-full md:w-5/12 p-4 flex items-center">
                <div className="hidden md:flex flex-wrap items-center justify-center">
                    <div className="flex flex-row w-full space-x-2 mb-2">
                        <img src="/img/1.png" alt="Luxury Hotel View 1" className="w-1/2 h-38 object-cover" />
                        <img src="/img/2.png" alt="Luxury Hotel View 2" className="w-1/2 h-38 object-cover" />
                    </div>
                    <div className="flex flex-row w-full space-x-2">
                        <img src="/img/3.png" alt="Luxury Hotel View 3" className="w-1/2 h-38 object-cover" />
                        <img src="/img/4.png" alt="Luxury Hotel View 4" className="w-1/2 h-38 object-cover" />
                    </div>
                </div>
                <div className="relative md:hidden">
                    <div 
                        ref={sliderRef}
                        className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide"
                    >
                        {[1, 2, 3, 4].map((num) => (
                            <div key={num} className="flex-none w-full snap-center">
                                <img 
                                    src={`/img/${num}.png`} 
                                    alt={`Luxury Hotel View ${num}`}
                                    className="w-full object-cover"
                                />
                            </div>
                        ))}
                    </div>
                    
                    <button 
                        onClick={() => handleSlide('left')}
                        className={`absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-r ${currentIndex === 0 ? 'hidden' : ''}`}
                    >
                        ←
                    </button>
                    <button 
                        onClick={() => handleSlide('right')}
                        className={`absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-l ${currentIndex === 3 ? 'hidden' : ''}`}
                    >
                        →
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ExclusiveSect;